<div class="tutorization--block__column">
  <div class="tutorization--block__row">
    <lms-widget-container class="tutorization--block__item" [widget]="totalWidget"></lms-widget-container>
    <lms-widget-container class="tutorization--block__item" [widget]="meanVotesWidget"></lms-widget-container>
    <lms-widget-container class="tutorization--block__item" [widget]="certifiedWidget"></lms-widget-container>
    <lms-widget-container class="tutorization--block__item" [widget]="canceledWidget"></lms-widget-container>
  </div>

  <div id="debates">
    <lms-debates-list #debates [listId]="listId" [options]="listOptions"></lms-debates-list>
  </div>
</div>
